var _rect, _rect2, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactIco2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 49,
    height: 49,
    rx: 6.5,
    fill: "black",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 6.5,
    fill: "#FBE8DE",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9635 19.8587C16.6053 17.5 18.2685 15.3812 20.8091 14.605C21.26 14.4671 21.7464 14.5064 22.1693 14.7147C22.5923 14.923 22.9198 15.2848 23.0853 15.7262L23.901 17.9012C24.0323 18.2511 24.056 18.6323 23.9692 18.9958C23.8823 19.3593 23.6888 19.6885 23.4135 19.9412L20.9872 22.1631C20.8676 22.2729 20.7785 22.4117 20.7286 22.5662C20.6786 22.7206 20.6695 22.8854 20.7022 23.0444L20.7247 23.1419L20.7828 23.3856C21.0846 24.5699 21.5443 25.7083 22.1497 26.77C22.8092 27.8982 23.6276 28.9256 24.5797 29.8206L24.6547 29.8881C24.7759 29.9956 24.9228 30.0699 25.0811 30.1038C25.2395 30.1376 25.404 30.1299 25.5585 30.0812L28.6953 29.0931C29.0518 28.9812 29.4337 28.9783 29.7918 29.0849C30.1499 29.1915 30.4681 29.4026 30.7054 29.6912L32.1904 31.4931C32.8091 32.2431 32.7341 33.3456 32.0235 34.0075C30.0791 35.8206 27.4053 36.1919 25.5453 34.6975C23.2654 32.8584 21.3434 30.6154 19.8753 28.0806C18.3954 25.5477 17.4068 22.7583 16.9616 19.8587H16.9635ZM22.6691 23.1681L24.6791 21.3231C25.23 20.8179 25.6174 20.1595 25.7915 19.4325C25.9655 18.7055 25.9184 17.9431 25.656 17.2431L24.8422 15.0681C24.5091 14.1798 23.8498 13.452 22.9988 13.0329C22.1477 12.6138 21.1688 12.535 20.2616 12.8125C17.106 13.7781 14.5728 16.6075 15.1091 20.1419C15.4841 22.6094 16.3485 25.7481 18.2553 29.0256C19.8392 31.7588 21.9125 34.1772 24.3716 36.16C27.1616 38.4006 30.8854 37.6356 33.3041 35.3819C33.9962 34.7375 34.4163 33.8532 34.4787 32.9097C34.541 31.9661 34.241 31.0343 33.6397 30.3044L32.1547 28.5006C31.6797 27.924 31.0432 27.5025 30.327 27.29C29.6107 27.0775 28.8474 27.0838 28.1347 27.3081L25.5303 28.1275C24.8579 27.4342 24.2689 26.6646 23.7753 25.8344C23.2986 24.995 22.927 24.1002 22.6691 23.17V23.1681Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIco2);
export default __webpack_public_path__ + "static/media/contact_ico2.a0750bfe53bcfa86e484fc0fa4523c0c.svg";
export { ForwardRef as ReactComponent };